"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listItem = void 0;
var List_1 = require("../Models/List");
var Common_1 = require("ContentTokens/Models/Common");
exports.listItem = {
    createToken: function (type, level) {
        return {
            type: "block",
            subType: "listItem",
            level: level || 1,
            listType: type || List_1.ListItemType.Bullet,
        };
    },
    createSlateJson: function (children, type, level) {
        return {
            type: Common_1.BlockType.ListItem,
            data: {
                level: level || 1,
                listType: type || List_1.ListItemType.Bullet,
            },
            children: children,
        };
    },
};
